import {useState} from 'react'
import {getSupplierBySite} from '../services'
import {SelectModel} from '../model'
import {mapDataSelect} from '../../../util/functions'
const useSupplierBySite = () => {
  const [loading, setLoading] = useState(false)
  const [supplierBySite, setSupplierBySite] = useState<SelectModel[]>([])

  const getSupplierBySiteAPI = async () => {
    return await getSupplierBySite()
  }

  const getSupplierBySiteData = async () => {
    setLoading(true)
    try {
      const response = await getSupplierBySiteAPI()
      return response.data.data
    } catch (error) {
      console.error('Error fetching service data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const updateSupplierBySiteList = (mappedSites: {value: string; label: string}[]) => {
    setSupplierBySite(mappedSites)
  }
  const getSupplierBySiteMappedData = async () => {
    try {
      const data = await getSupplierBySiteData()
      const mappedSites = mapDataSelect(data, 'id', 'razonSocial')
      return mappedSites
    } catch (error) {
      console.error('Error fetching service data:', error)
    }
  }
  const getSupplierBySiteList = async () => {
    try {
      const data = await getSupplierBySiteData()
      const mappedSites = mapDataSelect(data, 'id', 'razonSocial')
      updateSupplierBySiteList(mappedSites)
    } catch (error) {
      console.error('Error fetching service data:', error)
    }
  }

  const handleClear = () => {
    setSupplierBySite([])
  }

  return {
    loading,
    supplierBySite,
    getSupplierBySiteList,
    handleClear,
    getSupplierBySiteMappedData,
  }
}

export default useSupplierBySite
